<template>
    <div class="md-layout">
        <result-map :blocks="blocks" :isDashboardMap="true" :orgCustomisations="{}"></result-map>
    </div>
</template>

<script>
import ResultMap from "@/components/ResultMap/TheResultMap.vue"
export default {
    computed: {
        blocks(){
            return this.$store.getters['dashboard/getBlocks'];
        }
    },
    components: {
        ResultMap
    }
}
</script>

<style scoped>
.map-container {
    height: calc(100vh - 94px);
    width: 100%;
}
</style>